module.exports = __webpack_public_path__ + "img/9788972184591.1dbf22bf.jpg";